import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import { EditMedicationFollowupStatusDialog } from './types';

export const editMedicationFollowupStatusDialogState =
  atomWithReset<EditMedicationFollowupStatusDialog>({
    className: null,
  });

export const medicationFollowupSettingIdState = atom<string | null>(null);
